var _circle, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcArrowRight(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 50,
    viewBox: "0 0 49 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 24.5006,
    cy: 24.9652,
    r: 21.9052,
    transform: "rotate(-6 24.5006 24.9652)",
    fill: "white",
    fillOpacity: 0.61
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M37.2555 25.672C37.646 25.2814 37.646 24.6483 37.2555 24.2577L30.8915 17.8938C30.501 17.5033 29.8678 17.5033 29.4773 17.8938C29.0868 18.2843 29.0868 18.9175 29.4773 19.308L35.1342 24.9648L29.4773 30.6217C29.0868 31.0122 29.0868 31.6454 29.4773 32.0359C29.8678 32.4264 30.501 32.4264 30.8915 32.0359L37.2555 25.672ZM11.3574 25.9648H36.5484V23.9648H11.3574V25.9648Z",
    fill: "#FF6900"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcArrowRight);
export default __webpack_public_path__ + "static/media/ic_arrow-right.1a2e246a5ea9e6032d82162aa47682cb.svg";
export { ForwardRef as ReactComponent };